import Axios from "../../../../api/axios/Axios";

export { Axios };

export const creatorPath = (username) => {
  const value = String(username ?? "").trim();

  if (!value) {
    throw new Error("A valid creator username is required.");
  }

  return `/api/creators/${encodeURIComponent(value)}`;
};

export const grantIdPath = (grantId) => {
  const value = String(grantId ?? "").trim();

  if (!/^[1-9]\d*$/.test(value)) {
    throw new Error("A valid access grant ID is required.");
  }

  return encodeURIComponent(value);
};

export const recipientPayload = (form) => {
  const base = {
    recipientType: form.recipientType,
    accessScope: form.accessScope,
    expiresAt: form.expiresAt || null,
  };

  if (form.recipientType === "group") {
    return {
      ...base,
      groupId: Number(form.groupId),
    };
  }

  return form.userId
    ? {
        ...base,
        userId: Number(form.userId),
      }
    : {
        ...base,
        email: String(form.email || "")
          .trim()
          .toLowerCase(),
      };
};

export const makeLegacyAccessService = ({
  contentType,
  itemsKey,
  grantIdsKey,
}) => {
  const base = (username) => `${creatorPath(username)}/free-access`;

  const grants = (username) => `${base(username)}/grants`;

  const withContentType = (config = {}) => ({
    ...config,
    params: {
      ...config.params,
      contentType,
    },
  });

  return {
    contentType,
    itemsKey,
    grantIdsKey,

    getOptions: (username, config = {}) =>
      Axios.get(`${base(username)}/options`, withContentType(config)),

    getGrants: (username, config = {}) =>
      Axios.get(grants(username), withContentType(config)),

    saveGrant: (username, form, editingGrantId = null) => {
      const ids = form.accessScope === "selected" ? form.selectedIds || [] : [];

      const payload = {
        ...recipientPayload(form),
        contentType,
        [grantIdsKey]: ids,
      };

      if (editingGrantId == null) {
        return Axios.post(grants(username), payload);
      }

      return Axios.put(
        `${grants(username)}/${grantIdPath(editingGrantId)}`,
        payload,
      );
    },

    revokeGrant: (username, grantId) =>
      Axios.delete(`${grants(username)}/${grantIdPath(grantId)}`),
  };
};
